import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { Toaster } from '@/components/ui/sonner'

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootLayout,
  notFoundComponent: NotFound,
})

function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster position="bottom-right" />
    </>
  )
}

function NotFound() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 bg-canvas px-6">
      <p className="font-mono text-[13px] text-muted-foreground">404</p>
      <p className="text-[15px] font-medium">That page does not exist.</p>
      <Button asChild variant="outline" size="sm">
        <Link to="/">Back to sites</Link>
      </Button>
    </div>
  )
}
